import _ from 'lodash';
import AppConstants from "../../../../config/app.constants";

class BillingApprovalController {
  /*@ngInject*/
  constructor(Auth, $state, User, DataCounter, $translate, $q, Modal, $scope, DateUtil, SetupService, Navigation,
              BillingRecordsService, BillingCategoryService, CommonLayoutService, ServiceOrderService, UserBranchService, BillableEventsService, CustomerService, $rootScope) {

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.$scope = $scope;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.Navigation = Navigation;
    this.BillingRecordsService = BillingRecordsService;
    this.BillingCategoryService = BillingCategoryService;
    this.CommonLayoutService = CommonLayoutService;
    this.ServiceOrderService = ServiceOrderService;
    this.UserBranchService = UserBranchService;
    this.BillableEventsService = BillableEventsService;
    this.CustomerService = CustomerService;
    this.$rootScope = $rootScope;

    this.model = {
      loading: false,
      searchText: null,
      billingCategory:null,
      branch: User.getUser().branchId,
      billableCustomerObj: {
        totalPendingAmount: 0,
        totalPendingRecords: 0,
        totalApprovedAmount: 0,
        totalApprovedRecords: 0,
        totalUnassignedRecords: 0,
        totalUnassignedAmount: 0,
        totalDeletedRecords: 0,
        totalDeletedAmount: 0,
        totalReviewRecords: 0,
        totalReviewAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        customerHistory: {}
      },
      billingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        billingHistory: {},
        loading: false
      },
      billingRecordApproveObj: {},
      stats: {
        unassigned: 'unassigned',
        pending: 'pending',
        approved: 'approved',
        deleted: 'deleted',
        review: 'review',
        no_activity: 'no_activity'
      },
      billingCategoryObj: {
        totalRecords: 0,
        results: [],
        loading: false
      },
      billingTypeList: this.CommonLayoutService.billingTypeOptions(),
      // isApproved: false,
      unassignedStats: {
        customerAssigned: 'customerAssigned',
        customerNotAssigned: 'customerNotAssigned'
      },
      currentUnassignedStat: 'customerAssigned',
      unAssignedCustomersBillingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      dateRangeOptions: {
        startDate: null,
        endDate: null,
      },
      loggedInUser: User.getUser().id,
      userBranchList: [],
      billingEventListObj: {
        loading: false,
        results: [],
        totalRecords: 0
      },
      unassignedCustomerObj: {},
      pendingCustomerObj: {},
      approvedCustomerObj: {},
      rejectedCustomerObj: {},
      reviewCustomerObj: {},
      noActivityCustomerObj: {},
      staticBillingEventRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        billingHistory: {},
        loading: false
      },
      customerListObj: {
        totalRecords: 0,
        results: [],
        loading: false
      },
      noActivityBillingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      rejectedBillingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      billingReviewRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      hasActiveSurcharge: false,
      hasStoredSurcharge: false,
      surchargePeriodLabel: '',
      surchargeFilterAligned: true
    };

    this.model.currentStats = this.model.stats.pending;
    this.sortColumn = "vaultDate";
    this.reverseSort = true;
    this.deleteBillingRecordsObj = {};
    this.model.generatingStaticBillingRecord = {};
    this.undoApprovedBillingRecordsObj = {};
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/billing-approval');
    this.isCustomerUser = this.User.getUser().customerUser;

    this.surchargeTypes = ['INSURANCE', 'FUEL', 'SECURITY', 'LIABILITY'];
    this.surchargeIntervalLabelKeys = {
      WEEKLY: 'customer.surcharge_interval_weekly',
      BI_WEEKLY: 'customer.surcharge_interval_bi_weekly',
      MONTHLY: 'customer.surcharge_interval_monthly',
      QUARTERLY: 'customer.surcharge_interval_quarterly'
    };
    this.surchargeLabelKeys = {
      INSURANCE: 'customer.surcharge_insurance',
      FUEL: 'customer.surcharge_fuel',
      SECURITY: 'customer.surcharge_security',
      LIABILITY: 'customer.surcharge_liability'
    };
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [
      'branch_mgmt_billing_approval_create_billing_record',
      'branch_mgmt_billing_approval_approve_billing_record',
      'branch_mgmt_billing_approval_edit_billing_record',
      'branch_mgmt_billing_approval_delete_billing_record'
    ].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey);
      this.hasACL[permissionKey] = {};

      if (this.acl[permissionKey] && this.acl[permissionKey].length > 0) {
        this.acl[permissionKey].forEach((permission) => {
          this.hasACL[permissionKey][permission] = true;
        });
      }
    });
  }

  $onInit() {
    this.model.loading = true;
    for (const k of Object.keys(this.model.billingTypeList)) {
      this.model.billingTypeList[k].value = this.model.billingTypeList[k].value.toUpperCase()
    }

    this.$q.all([
      this.SetupService.get(this.model.branch),
      this.UserBranchService.getUserBranches(this.model.loggedInUser),
    ])
      .then((data) => {
        this.model.setupDetails = data[0];
        this.model.userBranchList = data[1].results;
        this.setDateRangeOptions('dateRangPickerOptionsfor');
        this.model.dateRangeOptions = {
          startDate: moment().startOf('months').format('YYYY-MM-DD'),
          endDate: moment().endOf('months').format('YYYY-MM-DD'),
        };

        this.loadPermission();
        this.getBillingCategory('', 0);
        this.getBillingEventsList('', 0);

        if (this.isCustomerUser) {
          this.getCustomerList('', 0).then(() => {
            if (!this.model.customerId) return;
            this.model.billableCustomerObj.pagination.page = 1;
            this.billableCustomer();
          });
        } else {
          this.loadData();
        }
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.loading = false;
      })
  }

  setDateRangeOptions(modelValue) {
    this.model[modelValue] = {
      autoApply: true,
      opens: "left",
      eventHandlers: {
        'apply.daterangepicker': () => {
          if (this.model.currentStats === this.model.stats.unassigned) this.loadUnassignedTabRecords();
          else if (this.model.currentStats === this.model.stats.deleted) {
            this.getRejectedRecords();
            // this.billableCustomer();
          }
          else this.loadData();
        }
      },
      ranges: {
        'Current Year': [
          moment().startOf('year').format('YYYY-MM-DD'),
          moment().endOf('year').format('YYYY-MM-DD')
        ],
        'Last 6 Months': [
          moment().subtract('5', 'months').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD')
        ],
        'Last 30 Days': [
          moment().subtract('29', 'days').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD')
        ],
        'Today': [
          moment().startOf('day').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD')
        ],
        'Previous Week': [
          moment().subtract(7, 'days').format('YYYY-MM-DD'),
          moment().subtract(1, 'day').format('YYYY-MM-DD')
        ],
        'Current Week': [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD')
        ],
        'Previous Month': [
          moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ],
        'Current Month': [
          moment().startOf('month').format('YYYY-MM-DD'),
          moment().endOf('month').format('YYYY-MM-DD')
        ],
      }
    };
  }

  getStartDate() {
    return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
  }

  getEndDate() {
    return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
  }

  billableCustomer() {
    setTimeout(() => {
      this.model.billableCustomerObj.customerHistory.process = true;
      const branches = this.model.selectedBranch && this.model.selectedBranch.length > 0 ? this.model.selectedBranch.map((branchObj) => branchObj.branchId) : null;
      const billingEventsId = this.model.billingEvents ? this.model.billingEvents.Value : null;
      const billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
      const searchText = this.model.searchText ? this.model.searchText : null;
      const customer = this.model.customerId ? this.model.customerId.Value : null;

      const startDate = this.getStartDate();
      const endDate = this.getEndDate();

      this.BillingRecordsService.getBillableCustomer(searchText, this.model.currentStats,
        (this.model.billableCustomerObj.pagination.page - 1) * this.model.billableCustomerObj.pagination.pageLimit,
        this.model.billableCustomerObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId, customer)
        .then((data) => {
          this.model.billableCustomerObj.results = data.results;
          this.model.billableCustomerObj.totalPendingAmount = data.totalPendingAmount;
          this.model.billableCustomerObj.totalPendingRecords = data.totalPendingRecords;
          this.model.billableCustomerObj.totalApprovedAmount = data.totalApprovedAmount;
          this.model.billableCustomerObj.totalApprovedRecords = data.totalApprovedRecords;
          this.model.billableCustomerObj.totalUnassignedAmount = data.totalUnassignedAmount;
          this.model.billableCustomerObj.totalReviewRecords = data.totalReviewRecords;
          this.model.billableCustomerObj.totalReviewAmount = data.totalReviewAmount;
          this.model.billableCustomerObj.totalNoActivityRecords = data.totalNoActivityRecords;
          this.model.billableCustomerObj.totalNoActivityAmount = data.totalNoActivityAmount;
          this.model.rejectedBillingRecordsObj.totalRecords = data.totalDeletedRecords;
          this.model.rejectedBillingRecordsObj.totalAmount = data.totalDeletedAmount;
          // this.model.billableCustomerObj.totalUnassignedRecords = data.totalUnassignedRecords;
          this.model.billableCustomerObj.customerAssignedTotalRecords = data.customerAssignedTotalRecords;
          this.model.billableCustomerObj.customerList = data.customerList;
          this.model.unassignedCustomerObj.totalUnAssignedBillableCustomers = data.totalUnAssignedBillableCustomers
          this.model.pendingCustomerObj.totalPendingBillableCustomers = data.totalPendingBillableCustomers;
          this.model.approvedCustomerObj.totalApprovedBillablecustomers = data.totalApprovedBillablecustomers;
          this.model.reviewCustomerObj.totalReviewBillablecustomers = data.totalReviewBillablecustomers;
          this.model.noActivityCustomerObj.totalNoActivityBillablecustomers = data.totalNoActivityBillablecustomers;
          this.applySurchargeTotals(this.model.billableCustomerObj.results, data);
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          this.model.billableCustomerObj.customerHistory.process = false;
        })
    }, 100)
  }

  setPage(isExpanded, customerId) {
    if (!isExpanded) return;
    this.model.billingRecordsObj.billingHistory[customerId] = { page: 1 };
  }

  getBillingRecords(data, event) {
    let branches = null, billingEventsId = null, billingCategoryId = null;
    document.getElementById(`expand-btn-${data.customerId}`).blur();

    if (!data.expanded && this.model.billingRecordsObj.billingHistory[data.customerId] && this.model.billingRecordsObj.billingHistory[data.customerId].details) {
      // if (data.isSelected) data.isSelected = false;
      this.model.billingRecordsObj.billingHistory[data.customerId].details.totalRecordSelected = 0;
      return;
    }
    else if (data.expanded && data.isSelected) {
      // data.isSelected = false;
    }

    const startDate = this.getStartDate();
    const endDate = this.getEndDate();

    if (this.model.currentStats == 'unassigned' && this.model.selectedBranch) {
      branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);
      billingEventsId = this.model.billingEvents ? this.model.billingEvents.Value : null;
    }
      billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
    this.model.billingRecordsObj.billingHistory[data.customerId].process = true;
    this.BillingRecordsService.getBillingRecords(this.model.searchText ? this.model.searchText : null, data.customerId, this.reverseSort, this.sortColumn, this.model.currentStats,
      (this.model.billingRecordsObj.billingHistory[data.customerId].page - 1) * this.model.billingRecordsObj.pagination.pageLimit,
      this.model.billingRecordsObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId)
      .then((history) => {
        this.model.billingRecordsObj.billingHistory[data.customerId].details = history;
        this.model.billingRecordsObj.billingHistory[data.customerId].details.pageLimit = this.model.billingRecordsObj.pagination.pageLimit;

        data.totalLocationServiced = history.totalLocationServiced;
        data.totalBillableEvents = history.totalRecords;

        this.model.billingRecordsObj.billingHistory[data.customerId].details.results.forEach((record) => {
          if (record.billingCategory) {
            record.billingCategoryObj = {};
            record.billingCategoryObj.Key = record.billingCategory;
          }

          if (data.isSelected) {
            record.isSelected = true;
          }
        })
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.billingRecordsObj.billingHistory[data.customerId].process = false;
      })
  }

  selectAllBillingRecords(data) {
    let totalSelected = 0;
    let totalRecords = data.totalBillableEvents;

    if (data.isSelected && this.model.billingRecordsObj.billingHistory[data.customerId] && data.expanded) {
      this.model.billingRecordsObj.billingHistory[data.customerId].details.results.forEach(d => d.isSelected = true);
      this.model.billingRecordsObj.billingHistory[data.customerId].details.totalRecordSelected = totalRecords;
    }
    else if (!data.isSelected && this.model.billingRecordsObj.billingHistory[data.customerId]) {
      this.model.billingRecordsObj.billingHistory[data.customerId].details.results.forEach(d => d.isSelected = false);
      this.model.billingRecordsObj.billingHistory[data.customerId].details.totalRecordSelected = totalSelected;
    }
  }

  goToServiceHistory(locationId) {
    return this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  goToRouteTab(routeId, vaultDate) {
    return this.Navigation.goToRouteTab(routeId, vaultDate, true, null);
  }

  goToContractRuleTab = (contractId) => {
    this.$state.go('contract.edit', ({
      id: contractId
    }))
  }

  tabSelection(selectedValue) {
    setTimeout(() => { 
      this.model.billingCategory = null;
      this.model.currentStats = selectedValue;
      this.model.dateRangeOptions = {
        startDate: null,
        endDate: null,
      }
      this.model.dateRangeOptions.startDate = moment().startOf('months').format('YYYY-MM-DD');
      this.model.dateRangeOptions.endDate = moment().endOf('months').format('YYYY-MM-DD');
      this.setDateRangeOptions('dateRangPickerOptionsfor');
      this.model.billableCustomerObj.pagination.page = 1;
      this.model.customerId = this.isCustomerUser ? this.model.customerListObj.results[0] : null;

      if (selectedValue === this.model.stats.approved) {
        this.reverseSort = false;
        this.sortColumn = 'vaultDate';
        this.loadData();
      }
      else if (selectedValue === this.model.stats.pending || selectedValue === this.model.stats.unassigned) {
        this.reverseSort = true;
        this.sortColumn = 'vaultDate';
        this.loadData();
      }
      else if (selectedValue === this.model.stats.deleted) {
        this.reverseSort = true;
        this.sortColumn = 'vaultDate';
        this.loadData();
      }
      else if (selectedValue === this.model.stats.review) {
        this.model.searchText=null
        this.reverseSort = true;
        this.sortColumn = 'vaultDate';
        this.loadData();
      }
      else if(selectedValue === this.model.stats.no_activity){
        this.loadData();
      }
      this.getBillingCategory('',0)
    })
  }

  validateBillingRecordSelection(billingRecord, customerObj) {
    let totalSelected = 0, length = this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.results.length;
    this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected = 0;

    setTimeout(() => {
      if (!billingRecord.isSelected && customerObj.isSelected) {
        customerObj.isSelected = false;
        this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected = length - 1;
      }
      else {
        this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.results.forEach(data => {
          if (data.isSelected) totalSelected++;

          this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected = totalSelected;
          if (totalSelected === length) customerObj.isSelected = false;
          if (customerObj.totalBillableEvents === totalSelected) customerObj.isSelected = true;
          // else customerObj.isSelected = false;
        });
      }
      this.$scope.$apply()
    })
  }

  billingRecordApproval(customerObj, billingRecord) {
    let totalAmount = 0, totalRecords = 0, records = [], obj = {};

    if (!customerObj.isSelected) {
      this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.results.forEach(data => {
        if (data.isSelected) {
          totalAmount += data.amountDue;
          totalRecords++;
          records.push({
            billingRecordId: data.billingRecordId,
            amount: data.amount,
            billingType: data.billingType,
            billingCategory: data.billingCategory,
            locationId: data.locationId,
            branchId: data.branchId,
            locationId: data.locationId,
            contractRuleId: data.contractRuleId,
            contractId: data.customerContractId,
            vaultDate: data.vaultDate,
            rate: data.rate,
            amountDue: data.amountDue
          })
        }
      });

      if (!this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected && billingRecord) {
        totalAmount = billingRecord.amountDue || 0;
        totalRecords++;
        records.push({
          billingRecordId: billingRecord.billingRecordId,
          amount: billingRecord.amount,
          billingType: billingRecord.billingType,
          billingCategory: billingRecord.billingCategory,
          locationId: billingRecord.locationId,
          branchId: billingRecord.branchId,
          locationId: billingRecord.locationId,
          contractRuleId: billingRecord.contractRuleId,
          contractId: billingRecord.customerContractId,
          vaultDate: billingRecord.vaultDate,
          rate: billingRecord.rate,
          amountDue: billingRecord.amountDue
        })
      }

      obj = {
        totalAmount: totalAmount,
        totalRecords: totalRecords,
        customer: customerObj.customerName
      }

    }
    else {
      obj = {
        totalAmount: customerObj.totalAmount,
        totalRecords: customerObj.totalBillableEvents,
        customer: customerObj.customerName
      }
    }

    obj.surchargeSelection = {
      customerId: customerObj.customerId,
      isApproveAllRecords: !!customerObj.isSelected,
      billingRecordIds: records.map((record) => record.billingRecordId),
      startDate: customerObj.isSelected ? this.getStartDate() : null,
      endDate: customerObj.isSelected ? this.getEndDate() : null,
      locationId: this.model.searchText,
      billingCategoryId: this.model.billingCategory ? this.model.billingCategory.Value : null
    };

    this.Modal.approveBillingRecords(obj, ({ supervisorId, modal, $scope }) => {
      $scope.model.loading = true;
      this.approve(customerObj, records, supervisorId, modal, $scope);
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  approve(customerObj, billingRecords, userId, modal = undefined, $scope) {
    // if (!customerObj.expanded) return;

    this.removeFocus(`approve-all-${customerObj.customerId}`);
    this.model.billingRecordApproveObj[customerObj.customerId] = { process: true };

    const startDate = customerObj.isSelected ? this.getStartDate() : null;
    const endDate = customerObj.isSelected ? this.getEndDate() : null;
    billingRecords = customerObj.isSelected ? [] : billingRecords;
    const customerId = customerObj.customerId;
    const billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
    const locationId = this.model.searchText;

    this.BillingRecordsService.approveBillingRecords(billingRecords, userId, customerObj.isSelected, startDate, endDate, customerId, locationId, billingCategoryId)
      .then(() => {
        modal.close();
        this.billableCustomer();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        $scope.model.loading = false;
        if (modal) modal.close();
        this.model.billingRecordApproveObj[customerObj.customerId].process = false;
      })
  }

  removeFocus(id) {
    if (!id) return;
    return document.getElementById(id).blur();
  }

  sortData(column, obj, event) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
    this.getBillingRecords(obj, event);
  }

  loadData() {
    if (this.model.currentStats === this.model.stats.pending) {
      this.model.billableCustomerObj.pagination.page = 1;
      this.billableCustomer();
      this.getCustomerList('', 0);
    }
    else if (this.model.currentStats === this.model.stats.approved) {
      this.model.billableCustomerObj.pagination.page = 1;
      this.billableCustomer();
      this.getCustomerList('', 0);
    }
    else if (this.model.currentStats === this.model.stats.unassigned) {
      this.model.searchText = null;
      if (this.model.currentUnassignedStat === this.model.unassignedStats.customerNotAssigned) {
        this.model.unAssignedCustomersBillingRecordsObj.pagination.page = 1
        this.getUnassignedCustomerBillingRecords();
      } else {
        this.model.billableCustomerObj.pagination.page = 1;
        this.billableCustomer();
        this.getCustomerList('', 0);
      }
    }
    else if (this.model.currentStats === this.model.stats.deleted) {
      this.model.rejectedBillingRecordsObj.pagination.page = 1;
      this.getRejectedRecords();
    }
    else if (this.model.currentStats === this.model.stats.review) {
      this.model.billableCustomerObj.pagination.page = 1;
      this.billableCustomer();
      this.getCustomerList('', 0);
    }
    else if(this.model.currentStats === this.model.stats.no_activity){
      this.model.billableCustomerObj.pagination.page = 1;
      this.billableCustomer();
      this.getCustomerList('', 0);
    }
  }

  updateBillingRecords(billingRecordsObj, customerObj) {
    billingRecordsObj.isEdit = false;
    this.model.billingRecordsObj.billingHistory[customerObj.customerId].isUpdate = true;
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
    const selectedCustomerId = this.model.customerId ? this.model.customerId.Value : null;
    const selectedBillableEvent =  this.model.billingEvents ? this.model.billingEvents.Value : null;

    this.Modal.updateBillingRecords(billingRecordsObj, this.model.currentStats,
                                   ({ modal, locationId, customerId, billingCategory, billingType, amount, amountDue, isApproved, userId, $scope }) => {

        this.BillingRecordsService.updateBillingRecords(billingRecordsObj.billingRecordId, amount || null, amountDue || null, billingRecordsObj.branchId,
          billingCategory, billingType, locationId, customerId, this.model.currentStats, startDate, endDate, isApproved, userId, this.model.searchText, billingCategoryId, selectedCustomerId, selectedBillableEvent, $scope.model.billableEventId, $scope.model.billableEvent)
          .then((data) => {
            if (customerObj.customerId === customerId) {
              billingRecordsObj.rate = amount;
              billingRecordsObj.amountDue = amountDue;
              billingRecordsObj.billingCategoryObj.Key = billingCategory;
              let evtType = $scope.model.billableEventsObj.results.filter((billableEvt) => $scope.model.billableEventId === billableEvt.Value)[0]
              billingRecordsObj.billableEventType = evtType.type;
              billingRecordsObj.billingType = billingType;
              billingRecordsObj.locationId = locationId;
              if (data && data.storedSurchargeBreakdown) {
                billingRecordsObj.storedSurcharge = data.storedSurcharge;
                billingRecordsObj.storedSurchargeBreakdown = data.storedSurchargeBreakdown;
              }

              if (this.model.currentStats.toUpperCase() === 'UNASSIGNED') {
                // this.billableCustomer();
                this.model.billingRecordsObj.billingHistory[customerObj.customerId].page = 1;
                this.getBillingRecords(customerObj);
                this.model.billableCustomerObj.customerAssignedTotalRecords = this.model.billableCustomerObj.customerAssignedTotalRecords - 1;
                this.model.billableCustomerObj.totalUnassignedAmount = data.totalUnassignedAmount;
                this.model.billableCustomerObj.totalUnassignedRecords = data.totalUnassignedRecords;
              }
              else if (this.model.currentStats.toUpperCase() === 'PENDING') {
                this.model.billableCustomerObj.totalPendingAmount = data.totalPendingBucketAmount;
                this.model.billableCustomerObj.totalPendingRecords = data.totalPendingRecords;
              }
              else if (this.model.currentStats.toUpperCase() === 'APPROVED') {
                this.model.billableCustomerObj.totalApprovedAmount = data.totalApprovedAmount;
                this.model.billableCustomerObj.totalApprovedRecords = data.totalApprovedRecords;
              }
              else if (this.model.currentStats.toUpperCase() === 'REVIEW') {
                this.model.billableCustomerObj.totalReviewAmount = data.totalReviewBucketAmount;
                this.model.billableCustomerObj.totalReviewRecords = data.totalReviewRecords;
              }
              customerObj.totalAmount = data.totalPendingAmount;
              this.billableCustomer();
            }
            else {
              this.billableCustomer();
            }
          })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              this.Modal.errorModal(err.data.message);
            }
          })
          .finally(() => {
            modal.close();
            this.model.billingRecordsObj.billingHistory[customerObj.customerId].isUpdate = false;
            $scope.isLoading = false;
          })
      }, ({ modal }) => {
        if (modal) modal.close();
        this.model.billingRecordsObj.billingHistory[customerObj.customerId].isUpdate = false;
      })
  }

  deleteBillingRecords(billingRecordsObj, from, customer = null) {
    this.deleteBillingRecordsObj[billingRecordsObj.billingRecordId] = { loading: true };
    const billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
    const selectedCustomerId = this.model.customerId ? this.model.customerId.Value : null;
    const selectedBillableEvent =  this.model.billingEvents ? this.model.billingEvents.Value : null;

    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message'),
      callback: (({
        modal,
        $scope
      }) => {
        let payload = {
          billingRecordId: billingRecordsObj.billingRecordId,
          userId: this.model.loggedInUser,
          branchId: billingRecordsObj.branchId,
          billingCategory: this.model.billingCategory,
          locationId: billingRecordsObj.locationId,
          routeId: billingRecordsObj.routeId,
          contractRuleId: billingRecordsObj.contractRuleId,
          contractRuleName: billingRecordsObj.contractRuleName,
          customerId: billingRecordsObj.customerId,
          rate: billingRecordsObj.rate,
          vaultDate: billingRecordsObj.vaultDate,
          contractId: billingRecordsObj.customerContractId,
          startDate: this.getStartDate(),
          endDate: this.getEndDate(),
          currentStat: from,
          searchText: this.model.searchText,
          selectedBillingCategoryId: billingCategoryId,
          selectedCustomerId,
          selectedBillableEvent
        };

        this.BillingRecordsService.deleteBillingRecord(payload)
          .then(res => {
            if (customer) {
              this.model.billingRecordsObj.billingHistory[customer.customerId].page = 1;
              this.getBillingRecords(customer);
            }

            if (from === "NOT_ASSIGNED") {
              this.getUnassignedCustomerBillingRecords()
            }

            if (from === "ASSIGNED" || from === "NOT_ASSIGNED") {
              this.model.billableCustomerObj.totalUnassignedAmount = res[from].totalBucketAmount;
              this.model.billableCustomerObj.customerAssignedTotalRecords = res[from].totalRecords;
              if (customer) customer.totalAmount = res[from].totalAmount;
            }

            if (from === "PENDING") {
              this.model.billableCustomerObj.totalPendingAmount = res[from].totalBucketAmount;
              this.model.billableCustomerObj.totalPendingRecords = res[from].totalRecords;
              if (customer) customer.totalAmount = res[from].totalAmount;
            }

            if (from === "REVIEW") {
              this.model.billableCustomerObj.totalReviewAmount = res[from].totalBucketAmount;
              this.model.billableCustomerObj.totalReviewRecords = res[from].totalRecords;
              if (customer) customer.totalAmount = res[from].totalAmount;
            }

            modal.close();
          })
          .catch(err => {
            modal.close();
            this.Modal.errorModal(err.data.message);
          })
          .finally(() => {
            this.deleteBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
          })
      }),
      negative: (({
        modal,
      }) => {
        modal.close();
        this.deleteBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
      }),
      type: 'danger'
    })
  }

  getBillingCategory(searchKey, offset) {
    searchKey = searchKey || '';
    const billingCategorySearchObj = {
      queryJSON: {
          rules: [{
              group: {
                  rules: [{
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                  }],
                  operator: 'OR'
              }
          }],
          operator: 'AND'
      }
  }

    this.model.billingCategoryObj.loading = true;
    this.BillingCategoryService.all(billingCategorySearchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.model.billingCategoryObj.totalRecords = data.total;
          this.model.billingCategoryObj.results = this.billingCategoryMap(data.results);
        }
        else {
          const results = this.billingCategoryMap(data.results);
          this.model.billingCategoryObj.results = this.model.billingCategoryObj.results.concat(results);
        }
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
      .finally(() => {
        this.model.billingCategoryObj.loading = false;
      })
  }

  billingCategoryMap(events) {
    return events.map((data) => {
      return {
        Key: data.name,
        Value: data.id
      }
    });
  }

  goToBillableEventsTab(billingRecordsObj) {
    const obj = {
      searchText: billingRecordsObj.trackingId,
      branchId: billingRecordsObj.branchId,
      billableEvent: billingRecordsObj.billableEventType,
      createdAt: billingRecordsObj.createdAt,
      isRedirected: true
    }

    this.DataCounter.setData(obj);
    this.$state.go('log.all', {
      page: 1
    });
  }

  resetData(customerObj) {
    if (!customerObj) {
      customerObj.isSelected = false;
    }
  }

  translateMessage(prefix, key) {
    if (!key) return;
    return this.$translate.instant(prefix.concat(key));
  }

  billableEventLogDetails(billingRecordsObj) {
    const obj = {
      searchText: {
        trackingId: billingRecordsObj.trackingId,
        serviceOrderId: billingRecordsObj.serviceOrderId,
        encounterId:  billingRecordsObj.encounterId,
        billingId: billingRecordsObj.billingId || billingRecordsObj.billingRecordId,
      },
      branchId: billingRecordsObj.branchId,
      billableEvent: billingRecordsObj.billableEventType,
      createdAt: billingRecordsObj.createdAt,
      startDate: moment.utc(billingRecordsObj.createdAt).format('YYYY-MM-DD 00:00:00'),
      endDate: moment.utc(billingRecordsObj.createdAt).add(1, 'days').format('YYYY-MM-DD 23:59:59'),
      customerContractId: billingRecordsObj.customerContractId,
      contractName: billingRecordsObj.contractName,
      contractRuleName: billingRecordsObj.contractRuleName,
      locationId: billingRecordsObj.locationId,
      vaultDate: billingRecordsObj.vaultDate
    }

    this.Modal.billableEventLogDetails(obj, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  unassignedTabSelection(selectedValue) {
    this.model.currentUnassignedStat = selectedValue;

    if (this.model.currentUnassignedStat === this.model.unassignedStats.customerAssigned) {
      // this.model.unAssignedCustomersBillingRecordsObj = {
      //   totalRecords: 0,
      //   totalAmount: 0,
      //   results: [],
      //   pagination: {
      //     page: 1,
      //     total: 0,
      //     pageLimit: 10,
      //     maxPages: 10
      //   }
      // }
      this.model.dateRangeOptions.startDate = moment().startOf('months').format('YYYY-MM-DD');
      this.model.dateRangeOptions.endDate = moment().endOf('months').format('YYYY-MM-DD');
      this.setDateRangeOptions('dateRangPickerOptionsfor');
      this.reverseSort = true;
      this.sortColumn = 'vaultDate';
      this.model.billableCustomerObj.pagination.page = 1;
      this.model.customerId = this.isCustomerUser ? this.model.customerListObj.results[0] : null;
      this.filterRecords();
      this.getCustomerList('', 0);
    }
    else {
      this.model.dateRangeOptions.startDate = moment().startOf('months').format('YYYY-MM-DD');
      this.model.dateRangeOptions.endDate = moment().endOf('months').format('YYYY-MM-DD');
      this.reverseSort = false;
      this.sortColumn = 'vaultDate';
      this.setDateRangeOptions('dateRangPickerOptionsfor');
      this.model.unAssignedCustomersBillingRecordsObj.pagination.page = 1;
      this.getUnassignedCustomerBillingRecords();
    }
  }

  getUnassignedCustomerBillingRecords() {
    setTimeout(() => {
      this.model.unAssignedCustomersBillingRecordsObj.loading = true;
      const startDate = this.getStartDate();
      const endDate = this.getEndDate();
      const branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);
      const billingEventsId = this.model.billingEvents ? this.model.billingEvents.Value : null;
      const billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;

      this.BillingRecordsService.getBillingRecords(this.model.searchText, null, this.reverseSort, this.sortColumn, this.model.currentStats,
        (this.model.unAssignedCustomersBillingRecordsObj.pagination.page - 1) * this.model.unAssignedCustomersBillingRecordsObj.pagination.pageLimit,
        this.model.unAssignedCustomersBillingRecordsObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId)
        .then((history) => {
          this.model.unAssignedCustomersBillingRecordsObj.records = history.results;
          this.model.unAssignedCustomersBillingRecordsObj.totalRecords = history.totalRecords;
          this.model.unAssignedCustomersBillingRecordsObj.records.forEach((record) => {
            if (record.billingCategory) {
              record.billingCategoryObj = {};
              record.billingCategoryObj.Key = record.billingCategory;
            }
          })

          // this.model.billableCustomerObj.totalPendingAmount = history.totalPendingAmount;
          // this.model.billableCustomerObj.totalPendingRecords = history.totalPendingRecords;
          // this.model.billableCustomerObj.totalApprovedAmount = history.totalApprovedAmount;
          // this.model.billableCustomerObj.totalApprovedRecords = history.totalApprovedRecords;
          this.model.billableCustomerObj.totalUnassignedAmount = history.totalUnassignedAmount;
          this.model.billableCustomerObj.customerAssignedTotalRecords = history.totalUnassignedRecords;
        })
        .catch((err) => {
          console.log(err);
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          this.model.unAssignedCustomersBillingRecordsObj.loading = false;
        })
    }, 200);
  }

  sortUnassignedCustomerBillingRecords(column) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
    this.getUnassignedCustomerBillingRecords();
  }

  exportBillingRecords() {
    setTimeout(() => {
      const startDate = this.getStartDate();
      const endDate = this.getEndDate();
      const currentStat = ['pending', 'approved', 'deleted','review', 'no_activity'].includes(this.model.currentStats) ? 'other' : 'unassigned';
      let branches = null, billingEventsId = null, billingCategoryId = null,
          customerId = this.model.currentStats === 'deleted' && this.model.customerId ? this.model.customerId.Value : null;

      if (currentStat == 'unassigned' && this.model.selectedBranch) {
        branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);
        billingEventsId = this.model.billingEvents ? this.model.billingEvents.Value : null;
      }
      billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;

      let customerList;
      if (currentStat == 'unassigned' && this.model.currentUnassignedStat === this.model.unassignedStats.customerNotAssigned) customerList = [];
      else customerList = this.model.billableCustomerObj.customerList;

      let classesToAdd = ['glyphicon', 'glyphicon-refresh', 'fast-right-spinner'];
      document.getElementById(`export-btn-loading-${currentStat}`).classList.add(...classesToAdd);
      document.getElementById(`export-btn-${currentStat}`).classList.add('disabled');

      return this.BillingRecordsService.exportBillingReport(startDate, endDate, this.model.currentStats, customerList, this.model.currentUnassignedStat, this.model.searchText, branches, billingEventsId, billingCategoryId, customerId)
        .then(() => {})
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message)
          }
        })
        .finally(() => {
          document.getElementById(`export-btn-loading-${currentStat}`).classList.remove(...classesToAdd);
          document.getElementById(`export-btn-${currentStat}`).classList.remove('disabled');
        })
    }, 100);
  }

  isAllowToTestStaticBill() {
    const firstName = this.User.getUser().firstName;
    const lastName = this.User.getUser().lastName;
    const userId = this.User.getUser().id;
    return ((firstName.toUpperCase() === 'COORWORKS' && lastName.toUpperCase() === 'ADMIN') || (lastName.toUpperCase() === 'COORWORKS' && firstName.toUpperCase() === 'ADMIN') && userId === 1000) && this.model.currentStats === this.model.stats.pending;
  }

  generateStaticBillingRecord(type) {
    this.model.generatingStaticBillingRecord[type] = { status: true };

    this.BillingRecordsService.generateStaticBillingRecord(type)
      .then(() => {
        this.loadData();
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
      .finally(() => {
        this.model.generatingStaticBillingRecord[type] = { status: false };
      })
  }

  updateCustomerNotAssignBillingRecords(billingRecordsObj) {
    this.model.billingRecordsObj.loading = true;
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();

    this.Modal.updateBillingRecords(billingRecordsObj, this.model.currentStats,
      ({ modal, locationId, customerId, billingCategory, billingType, amount, amountDue, isApproved, userId, $scope }) => {

        this.BillingRecordsService.updateBillingRecords(billingRecordsObj.billingRecordId, amount || null, amountDue || null, billingRecordsObj.branchId,
          billingCategory, billingType, locationId, customerId, this.model.currentStats, startDate, endDate, isApproved, userId, null, null, null,null, $scope.model.billableEventId, $scope.model.billableEvent)
          .then(() => {
            this.billableCustomer();
            this.getUnassignedCustomerBillingRecords();
          })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              this.Modal.errorModal(err.data.message);
            }
          })
          .finally(() => {
            modal.close();
            this.model.billingRecordsObj.loading = false;
            $scope.isLoading = false;
          })
      }, ({ modal }) => {
        if (modal) modal.close();
        this.model.billingRecordsObj.loading = false;
      })
  }

  serviceOrderNotes(data) {
    const vaultDate = this.DateUtil.getUTCDate(data.branchCurrentVaultDate);

    this.Modal.serviceOrderNotes(data, ({ modal, serviceOrderUserNote, serviceOrderNote }) => {
      this.ServiceOrderService.updateServiceOrderNote(data.encounterId, data.serviceOrderId, data.branchId, serviceOrderUserNote, serviceOrderNote, vaultDate, data.routeId, data.statusCode)
        .then(() => {
          modal.close();
          data.serviceOrderUserNote = serviceOrderUserNote;
          data.serviceOrderNote = serviceOrderNote;
        })
        .catch((err) => {
          console.log(err);
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
    })
  }

  selectNone() {
    if (this.model.selectedBranch && this.model.selectedBranch.length) {
      this.model.selectedBranch.forEach((branch) => {
        branch.ticked = false;
      })
      setTimeout(() => {
        this.loadUnassignedTabRecords();
      })
    }
  }

  resetSelectedBranch() {
    if (this.model.userBranchList && this.model.userBranchList.length) {
      this.model.userBranchList.forEach((branch) => {
        branch.ticked = false;
      })
      this.model.selectedBranch.forEach((branch) => {
        branch.ticked = false;
      })
      setTimeout(() => {
        this.loadUnassignedTabRecords();
      })
    }
  }
  
  loadUnassignedTabRecords() {
    if (this.model.currentStats === this.model.stats.unassigned) {
      if (this.model.currentUnassignedStat === this.model.unassignedStats.customerNotAssigned) {
        this.model.unAssignedCustomersBillingRecordsObj.pagination.page = 1;
        this.getUnassignedCustomerBillingRecords();
      } else {
        this.model.billableCustomerObj.pagination.page = 1;
        this.filterRecords();
      }
    }
  }
  
  reset() {
    if (this.model.userBranchList && this.model.userBranchList.length) {
      this.model.userBranchList.forEach((branch) => {
        branch.ticked = false;
      })
    }

    if (this.model.selectedBranch && this.model.selectedBranch.length) {
      this.model.selectedBranch.forEach((branch) => {
        branch.ticked = false;
      })
    }

    this.model.searchText = null;
    this.model.billingEvents = null;
    this.model.billingCategory = null;
  }

  getBillingEventsList(searchKey, offset) {
    searchKey = searchKey || '';

    const billingEventSearchObj = {
      queryJSON: {
        rules: [{
          group: {
            rules: [{
              field: 'type',
              condition: 'like',
              data: '%' + searchKey + '%'
            }],
            operator: 'OR'
          }
        }],
        operator: 'AND'
      }
    }

    this.model.billingEventListObj.loading = true;
    this.BillableEventsService.all(billingEventSearchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.model.billingEventListObj.totalRecords = data.total;
          this.model.billingEventListObj.results = this.billingEventsMap(data.results);
        }
        else {
          const results = this.billingEventsMap(data.results);
          this.model.billingEventListObj.results = this.model.billingEventListObj.results.concat(results);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.billingEventListObj.loading = false;
      })
  }

  billingEventsMap(events) {
    return events.map((data) => {
      return {
        Key: this.$translate.instant('entry_type.' + data.type),
        Value: data.id
      }
    });
  }

  filterRecords() {
    setTimeout(() => {
      this.model.filterRecords = true;
      let branches = null, billingEventsId = null, searchText = null, billingCategoryId = null, customer = null;

      if (this.model.currentStats == 'unassigned' && this.model.selectedBranch) {
        branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);
        billingEventsId = this.model.billingEvents ? this.model.billingEvents.Value : null;
        searchText = this.model.searchText;
        billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
        customer = this.model.customerId ? this.model.customerId.Value : null;
      }

      const startDate = this.getStartDate();
      const endDate = this.getEndDate();

      this.BillingRecordsService.getBillableCustomer(searchText, this.model.currentStats,
        (this.model.billableCustomerObj.pagination.page - 1) * this.model.billableCustomerObj.pagination.pageLimit,
        this.model.billableCustomerObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId, customer)
        .then((data) => {
          this.model.billableCustomerObj.results = data.results;
          this.model.billableCustomerObj.totalPendingAmount = data.totalPendingAmount;
          this.model.billableCustomerObj.totalPendingRecords = data.totalPendingRecords;
          this.model.billableCustomerObj.totalApprovedAmount = data.totalApprovedAmount;
          this.model.billableCustomerObj.totalApprovedRecords = data.totalApprovedRecords;
          this.model.billableCustomerObj.totalUnassignedAmount = data.totalUnassignedAmount;
          this.model.rejectedBillingRecordsObj.totalRecords = data.totalDeletedRecords;
          this.model.rejectedBillingRecordsObj.totalAmount = data.totalDeletedAmount;
          // this.model.billableCustomerObj.totalUnassignedRecords = data.totalUnassignedRecords;
          this.model.billableCustomerObj.customerAssignedTotalRecords = data.customerAssignedTotalRecords;
          this.model.billableCustomerObj.customerList = data.customerList;
          this.model.unassignedCustomerObj.totalUnAssignedBillableCustomers = data.totalUnAssignedBillableCustomers
          this.model.pendingCustomerObj.totalPendingBillableCustomers = data.totalPendingBillableCustomers;
          this.model.approvedCustomerObj.totalApprovedBillablecustomers = data.totalApprovedBillablecustomers;
          this.applySurchargeTotals(this.model.billableCustomerObj.results, data);
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          this.model.filterRecords = false;
        })
    })
  }

  applySurchargeTotals(results, data) {
    this.model.hasStoredSurcharge = (results || []).some((customer) => Number(customer.storedSurcharge) > 0);

    if (!results || results.length === 0) {
      this.model.hasActiveSurcharge = false;
      return this.$q.resolve();
    }

    const customerIds = results.map((customer) => customer.customerId);
    const eventAmounts = (data && data.eventAmounts) || [];
    const periods = (data && data.surchargePeriods) || {};
    const cutoffs = (data && data.surchargeCutoffs) || {};
    const monthPeriod = periods.MONTHLY || null;
    const chargeOnTheseRecords = this.model.currentStats === this.model.stats.approved;

    this.model.surchargePeriodLabel = this.formatSurchargePeriod(periods.MONTHLY);
    this.model.surchargeFilterAligned = !data || data.surchargeFilterAligned !== false;

    return this.CustomerService.getSurchargeConfigBulk(customerIds)
      .then((surchargeConfigByCustomer) => {
        this.model.surchargeConfigByCustomer = surchargeConfigByCustomer;
        const eventAmountsByCustomer = {};
        eventAmounts.forEach((row) => {
          eventAmountsByCustomer[row.customerId] = eventAmountsByCustomer[row.customerId] || {};
          const byEvent = eventAmountsByCustomer[row.customerId];
          byEvent[row.billableEventId] = byEvent[row.billableEventId] || {};
          byEvent[row.billableEventId][row.periodKey] = {
            amount: Number(row.amount) || 0,
            filterAmount: Number(row.filterAmount) || 0
          };
        });

        let hasActiveSurcharge = false;

        results.forEach((customer) => {
          const customerEventAmounts = eventAmountsByCustomer[customer.customerId] || {};
          const customerSurcharges = surchargeConfigByCustomer[customer.customerId] || {};
          const surchargeBreakdown = [];
          let totalSurcharge = 0;
          let totalPeriodSurcharge = 0;
          let widerWindowStart = null;

          this.surchargeTypes.forEach((type) => {
            const typeConfig = customerSurcharges[type];
            if (!typeConfig || !typeConfig.enabled) return;

            hasActiveSurcharge = true;

            const interval = typeConfig.interval || 'MONTHLY';
            const cutoff = cutoffs[interval] || cutoffs.MONTHLY || null;
            const period = periods[interval] || periods.MONTHLY || null;

            const base = (typeConfig.billableEventIds || []).reduce((acc, billableEventId) => {
              const buckets = customerEventAmounts[billableEventId] || {};
              Object.keys(buckets).forEach((monthKey) => {
                acc.filter += buckets[monthKey].filterAmount;
                if (this.isMonthInSurchargePeriod(monthKey, period)) acc.period += buckets[monthKey].amount;
              });
              return acc;
            }, { filter: 0, period: 0 });

            const percentage = Number(typeConfig.percentage) || 0;
            const amount = base.filter * percentage / 100;
            const periodAmount = base.period * percentage / 100;

            if (period && monthPeriod && period.start < monthPeriod.start
              && (!widerWindowStart || period.start < widerWindowStart)) {
              widerWindowStart = period.start;
            }

            surchargeBreakdown.push({
              type,
              labelKey: this.surchargeLabelKeys[type],
              percentage: typeConfig.percentage,
              interval,
              intervalLabelKey: this.surchargeIntervalLabelKeys[interval] || '',
              period,
              periodLabel: this.formatSurchargePeriod(period),
              cutoff,
              cutoffLabel: cutoff ? moment(cutoff.date).format('DD-MMM-YYYY') : '',
              coverageLabel: (period && cutoff) ? this.formatSurchargePeriod({ start: period.start, end: cutoff.date }) : '',
              isFinal: !!(cutoff && cutoff.isFinal),
              amount,
              periodBase: base.period,
              periodAmount,
              displayAmount: chargeOnTheseRecords ? amount : periodAmount
            });
            totalSurcharge += amount;
            totalPeriodSurcharge += periodAmount;
          });

          customer.surchargeBreakdown = surchargeBreakdown;
          customer.widerSurchargeWindowStart = widerWindowStart
            ? moment(widerWindowStart).format('DD-MMM-YYYY')
            : null;
          customer.totalRecordSurcharge = totalSurcharge;
          customer.totalPeriodSurcharge = totalPeriodSurcharge;
          customer.totalSurcharge = chargeOnTheseRecords ? totalSurcharge : totalPeriodSurcharge;
          customer.totalPending = (Number(customer.totalAmount) || 0) + customer.totalSurcharge;
        });

        this.model.hasActiveSurcharge = hasActiveSurcharge;
      })
      .catch(() => {
        this.model.hasActiveSurcharge = false;
      });
  }

  isMonthInSurchargePeriod(monthKey, period) {
    if (!monthKey || !period || !period.start || !period.end) return false;
    return monthKey >= period.start && monthKey <= period.end;
  }

  isSurchargeAffected(billingRecordsObj) {
    if (!billingRecordsObj) return false;
    const customerSurcharges = (this.model.surchargeConfigByCustomer || {})[billingRecordsObj.customerId] || {};

    return this.surchargeTypes.some((type) => {
      const typeConfig = customerSurcharges[type];
      return !!typeConfig && typeConfig.enabled
        && (typeConfig.billableEventIds || []).indexOf(billingRecordsObj.billableEventId) !== -1;
    });
  }

  formatSurchargePeriod(period) {
    if (!period || !period.start || !period.end) return '';
    return `${moment(period.start).format('DD-MMM-YYYY')} - ${moment(period.end).format('DD-MMM-YYYY')}`;
  }

  showStoredSurchargeDetails(customer) {
    const modal = this.Modal.storedSurchargeDetails({ customer, labelKeys: this.surchargeLabelKeys });

    if (modal && modal.result) {
      modal.result.finally(() => {
        setTimeout(() => {
          if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
          }
        });
      });
    }
  }

  showSurchargeDetails(customer) {
    const modal = this.Modal.surchargeDetails({
      customer,
      periodLabel: this.model.surchargePeriodLabel,
      filterAligned: this.model.surchargeFilterAligned,
      onTheseRecords: this.model.currentStats === this.model.stats.approved
    });

    if (modal && modal.result) {
      modal.result.finally(() => {
        setTimeout(() => {
          if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
          }
        });
      });
    }
  }

  setStaticBillingEventsRecordsPage(isExpanded, billingRecordId) {
    if (!isExpanded) return;
    this.model.staticBillingEventRecordsObj.billingHistory[billingRecordId] = { page: 1 };
  }

  getStaticBillingEventsRecords(data, staticBillingCategory) {
    document.getElementById(`expand-btn-${data.billingRecordId}`).blur();
   
    if (!data.expanded) return;

    staticBillingCategory = staticBillingCategory === 'pre-bill' ? 'PRE_BILL' : 'POST_BILL';
    this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].process = true;

    this.BillingRecordsService.getStaticBillingEventsRecords(staticBillingCategory, data.vaultDate, data.customerContractId, data.contractRuleId, data.locationId,
      this.model.staticBillingEventRecordsObj.pagination.pageLimit, (this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].page - 1)
    * this.model.staticBillingEventRecordsObj.pagination.pageLimit, this.model.currentStats)
      .then((history) => {
        this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].details = history;
        this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].details.pageLimit = this.model.staticBillingEventRecordsObj.pagination.pageLimit;        
        this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].details.results.forEach((record) => {
          if (record.billingCategory) {
            record.billingCategoryObj = {};
            record.billingCategoryObj.Key = record.billingCategory;
          }
        })
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].process = false;
      })
  }

  getCustomerList(searchKey, offset) {
    searchKey = searchKey || '';

    const customerSearchObj = {
      queryJSON: {
        rules: [
          {
            field: 'isEnabled',
            condition: '=',
            data: true
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };

    if (this.isCustomerUser) {
      customerSearchObj.queryJSON.rules.push({
        field: 'id',
        condition: '=',
        data: this.User.getUser().customerId
      })
    }
    
    this.model.customerListObj.loading = true;
    return this.CustomerService.all(customerSearchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
          this.model.customerListObj.loading = true;
          if (offset === 0 || offset == undefined) {
            this.model.customerListObj.totalRecords = data.total;
            this.model.customerListObj.results = this.customerMapping(data.results);
          } else {
            const customers = this.customerMapping(data.results);
            this.model.customerListObj.results = this.model.customerListObj.results.concat(customers);
          }

        if (this.isCustomerUser) {
          this.model.customerId = this.model.customerListObj.results[0];
        }
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.customerListObj.loading = false;
      })
  }

  customerMapping(customers) {
    return customers.map((customer) => {
      return {
        Key: customer.id + ' | ' + customer.name,
        Value: customer.id
      }
    });
  }

  getRejectedRecords() {
    setTimeout(() => {
      let  billingCategoryId;
      this.model.rejectedBillingRecordsObj.loading = true;
      const startDate = this.getStartDate();
      const endDate = this.getEndDate();
      const customer = this.model.customerId ? this.model.customerId.Value : null;
      billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;

      this.BillingRecordsService.getBillingRecords(this.model.searchText, customer, this.reverseSort, this.sortColumn, this.model.currentStats,
        (this.model.rejectedBillingRecordsObj.pagination.page - 1) * this.model.rejectedBillingRecordsObj.pagination.pageLimit,
        this.model.rejectedBillingRecordsObj.pagination.pageLimit, startDate, endDate, [], null, billingCategoryId)
        .then((history) => {
          this.model.rejectedBillingRecordsObj.records = history.results;
          this.model.rejectedBillingRecordsObj.totalRecords = history.totalRecords;
          this.model.rejectedBillingRecordsObj.totalAmount = history.totalDeletedAmount;

          this.model.billableCustomerObj.totalPendingAmount = history.totalPendingAmount;
          this.model.billableCustomerObj.totalPendingRecords = history.totalPendingRecords;
          this.model.billableCustomerObj.totalApprovedAmount = history.totalApprovedAmount;
          this.model.billableCustomerObj.totalApprovedRecords = history.totalApprovedRecords;
          this.model.billableCustomerObj.totalUnassignedAmount = history.totalUnassignedAmount;
          this.model.billableCustomerObj.customerAssignedTotalRecords = history.totalUnassignedRecords;
          this.model.billableCustomerObj.totalReviewAmount = history.totalReviewAmount;
          this.model.billableCustomerObj.totalReviewRecords = history.totalReviewRecords;

          this.model.rejectedBillingRecordsObj.records.forEach((record) => {
            if (record.billingCategory) {
              record.billingCategoryObj = {};
              record.billingCategoryObj.Key = record.billingCategory;
            }
          })
        })
        .catch((err) => {
          console.log(err);
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          this.model.rejectedBillingRecordsObj.loading = false;
        })
    }, 200);
  }

  sortRejectedBillingRecords(column) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
    this.getRejectedRecords();
  }

  exportRejectedBillingRecords() {
    this.model.currentUnassignedStat = null;
    this.exportBillingRecords();
  }

  postBillingRecordModal(type) {
    this.Modal.postBillingRecord(({ modal, month, contractId, $scope }) => {
      $scope.isLoading = true;
      this.BillingRecordsService.createPostBillingRecords(month, contractId)
        .then(() => {
          modal.close();
          this.loadData();
        })
        .catch((err) => {
          this.Modal.errorModal(err.data.message);
        })
        .finally(() => {
          $scope.isLoading = false;
        })
    }, ({ modal }) => {
      modal.close();
    });
  }

  undoApprovedBillingRecords(billingRecordsObj, status, customer) {
    this.undoApprovedBillingRecordsObj[billingRecordsObj.billingRecordId] = { loading: true };

    let description = this.$translate.instant('branch_mgmt.billing_approval.unapprove_message');

    if (billingRecordsObj.type !== 'MANUAL') {
      description = description.concat(' ', this.$translate.instant('branch_mgmt.billing_approval.unapprove_static_note'));
    }

    if (this.isSurchargeAffected(billingRecordsObj)) {
      description = description.concat(' ', this.$translate.instant('branch_mgmt.billing_approval.unapprove_surcharge_warning'));
    }

    this.Modal.confirm({
      header: this.$translate.instant('branch_mgmt.billing_approval.unapprove_title'),
      message: description,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true;
        const data = {
          billingRecordId: billingRecordsObj.billingRecordId,
          rate: billingRecordsObj.rate,
          branchId: billingRecordsObj.branchId,
          billingCategory: billingRecordsObj.billingCategory,
          billingType: billingRecordsObj.billingType,
          amountDue: billingRecordsObj.amountDue,
          status,
          customerId: billingRecordsObj.customerId,
          locationId: billingRecordsObj.locationId,
          startDate: this.getStartDate(),
          endDate: this.getEndDate(),
          userId: this.model.loggedInUser,
          contractId: billingRecordsObj.customerContractId,
          contractRuleId: billingRecordsObj.contractRuleId,
          vaultDate: billingRecordsObj.vaultDate
        }

        this.BillingRecordsService.undoApproveBillingRecords(data)
          .then(() => {
            modal.close();
            this.billableCustomer();
          })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              this.Modal.errorModal(err.data.message);
            }
            else {
              this.Modal.errorModal(err);
            }
          })
        .finally(() => {
          this.undoApprovedBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
        })
      }),
      negative: (({
        modal,
      }) => {
        modal.close();
        this.undoApprovedBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
      }),
      type: 'danger'
    })
  }
  
  createBillingRecords() {
    this.Modal.createBillingRecords(({ modal, billingStatus, vaultDate, rate, amountDue, billableEventId, billingCategory, billingType, scheduleType, locationId, branchId, customerContractId, contract, customerId, contractRuleId, contractRule, $scope }) => {
      const data = { billingStatus, vaultDate, rate, amountDue, billableEventId, billingCategory, billingType, scheduleType, locationId, branchId, customerContractId, contract, customerId, contractRuleId, contractRule };
      this.BillingRecordsService.createBillingRecords(data)
        .then(() => {
          modal.close();
          this.loadData();
        })
        .catch((err) => {
          this.Modal.errorModal(err.data.message);
        })
        .finally(() => {
          $scope.isLoading = false;
        })
    }, ({ modal }) => {
      modal.close();
    });
  }

  manuallyCreatedBillingRecordsLog(billingRecordsObj) {
    const obj = { billingRecordId: billingRecordsObj.billingRecordId, recordType: 'MANUAL', searchText: billingRecordsObj.billingRecordId };

    this.Modal.billableEventLogDetails(obj, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  coinConversionBillingRecordsLog(billingRecordsObj) {
    const obj = {
      recordType: 'MANUAL',
      searchText: billingRecordsObj.billingRecordId,
      billingRecordId: billingRecordsObj.billingRecordId,
      branchId: billingRecordsObj.branchId,
      billableEvent: billingRecordsObj.billableEventType,
      createdAt: billingRecordsObj.createdAt,
      startDate: moment.utc(billingRecordsObj.createdAt).format('YYYY-MM-DD 00:00:00'),
      endDate: moment.utc(billingRecordsObj.createdAt).add(1, 'days').format('YYYY-MM-DD 23:59:59'),
      customerContractId: billingRecordsObj.customerContractId,
      contractName: billingRecordsObj.contractName,
      contractRuleName: billingRecordsObj.contractRuleName,
      locationId: billingRecordsObj.locationId,
      vaultDate: billingRecordsObj.vaultDate
    }

    this.Modal.billableEventLogDetails(obj, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

}

export default BillingApprovalController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/billing_approval/billing_approval.controller.js